<div class="wrapper">
  <div id="zone"  >
    Assigned to furtilizer {{ GetValue(furtilizer) }}
  </div>
</div>
<div class="wrapper">
  <div id="drain" >
    Assigned to drain {{ GetValue(drain) }}
  </div>

</div>


